/**
 * Vue Router
 *
 * @author minkyoung.park@emcast.com
 */

// Components Define
import Vue from "vue";
import Router from "vue-router";
import loginApi from "@/api/loginApi.js";

import BrandSelect from "@/views/BrandSelect.vue";
import Login from "@/views/Login.vue";
import Home from "@/views/Home.vue";
import PcHome from "@/views/pc/Home.vue";
import Terms from "@/components/common/Terms.vue";
import Privacy from "@/components/common/Privacy.vue";
import Certification from "@/views/Certification.vue";
import Error from "@/views/Error.vue";
import ErrorNetwork from "@/components/error/Network.vue";
import ReasonChoice from "@/components/common/reasonChoice/ReasonChoice.vue";

// Reset Password
import ResetPw from "@/views/ResetPw.vue";

//Check responsibility verification code verified. (true / false) If false
import VerificationCode from "@/components/loginResponsibility/Code.vue";

// Find Account
import FindId from "@/views/FindId.vue";
import FindIdStep1 from "@/components/findid/Step1.vue";
import FindIdStep2 from "@/components/findid/Step2.vue";
import FindIdStep3 from "@/components/findid/Step3.vue";
import FindIdStep4 from "@/components/findid/Step4.vue";
import FindIdComplete from "@/components/findid/Complete.vue";

// Find Code
import FindCode from "@/views/FindCode.vue";
import FindCodeStep1 from "@/components/findcode/Step1.vue";

// Find Password
import FindPw from "@/views/FindPw.vue";
import FindPwStep1 from "@/components/findpw/Step1.vue";
import FindPwStep2 from "@/components/findpw/Step2.vue";
import FindPwStep3 from "@/components/findpw/Step3.vue";
import FindPwStep4 from "@/components/findpw/Step4.vue";
import FindPwStep5 from "@/components/findpw/Step5.vue";
// import FindPwComplete from '@/components/findpw/Complete.vue'

// Sign Up
import Join from "@/views/Join.vue";
import JoinIntro from "@/components/join/Intro.vue";
import JoinRole from "@/components/join/Role.vue";
import JoinResponsibility from "@/components/join/Responsibility.vue";
import JoinPolicy from "@/components/join/Policy.vue";
import JoinTerms from "@/components/common/Terms.vue";
import JoinPrivacy from "@/components/common/Privacy.vue";
import JoinName from "@/components/join/Name.vue";
import JoinEmail from "@/components/join/Email.vue";
import JoinPassword from "@/components/join/Password.vue";
import JoinStore from "@/components/join/Store.vue";
import JoinComplete from "@/components/join/Complete.vue";
import JoinExistSocial from "@/components/join/ExistSocial.vue";
import JoinCode from "@/components/join/Code.vue";
import JoinSocialInput from "@/components/join/SocialInput.vue";

// New Sign Up
import Join2 from "@/views/Join2.vue";
import Join2Intro from "@/components/join2/Intro.vue";
import Join2Policy from "@/components/join2/Policy.vue";
import Join2Responsibility from "@/components/join2/Responsibility.vue";
import Join2Code from "@/components/join2/Code.vue";
import Join2Name from "@/components/join2/Name.vue";
import Join2Email from "@/components/join2/Email.vue";
import Join2Password from "@/components/join2/Password.vue";
import Join2Store from "@/components/join2/Store.vue";
import Join2CompleteApproved from "@/components/join2/CompleteApproved.vue";
import Join2CompleteUnapproved from "@/components/join2/CompleteUnapproved.vue";
import Join2SocialInput from "@/components/join2/SocialInput.vue";
import Join2ExistSocial from "@/components/join2/ExistSocial.vue";

// Member Withdrawal
import Withdrawal from "@/components/join/Withdrawal.vue";

// Degree
import Degree from "@/views/Degree.vue";
import DegreeView from "@/components/degree/View.vue";
import DegreeReviewList from "@/components/degree/review/List.vue";
// import DegreeLearnLesson from '@/components/degree/LearnLesson.vue'
import DegreeEnterAwait from "@/components/degree/EnterAwait.vue";

// Main Page

import Main from "@/components/main/Main";
import Search from "@/components/main/Search.vue";

// Popup Page
import Popup from "@/components/popup/Popup";

//Check terms agree. (true/false) If false
import TermsAgree from "@/components/termsAgree/Policy.vue";

// Learner
import Learn from "@/views/Learn.vue";
import LearnView from "@/components/learn/View.vue";
import LearnViewMission from "@/components/learn/mission/View.vue";
import LearnViewMissionSubmit from "@/components/learn/mission/Submit.vue";
import Study from "@/views/Study.vue";

// Exam
import ExamIntro from "@/components/exam/Intro.vue";
import ExamTake from "@/components/exam/Take.vue";
import ExamResult from "@/components/exam/Result.vue";
import ExamFeedback from "@/components/exam/Feedback.vue";
import ExamFeedbackIssue from "@/components/exam/FeedbackIssue.vue";

// Sales
import Sales from "@/views/Sales.vue";
import SalesInformation from "@/components/sales/Information.vue";
import SalesResultEnroll from "@/components/sales/ResultEnroll.vue";
import SalesResultBank from "@/components/sales/ResultBank.vue";
import SalesResultPaypal from "@/components/sales/ResultPaypal.vue";
import SalesCart from "@/components/sales/Cart.vue";
import SalesDuplicate from "@/components/sales/Duplicate.vue";

// Member
import Member from "@/views/Member.vue";
import EmailConfirm from "@/components/member/EmailConfirm.vue";
import EmailReconfirm from "@/components/member/EmailReconfirm.vue";
import MemberChangePassword from "@/components/member/ChangePassword.vue";
import MemberReIssueChangePassword from "@/components/member/ReIssueChangePassword.vue";
import MemberProfilePatten from "@/components/member/ProfilePatten.vue";
import MemberProfilePicture from "@/components/member/ProfilePicture.vue";
import MemberPurchase from "@/components/member/Purchase.vue";
import MemberPurchaseView from "@/components/member/PurchaseView.vue";
import MemberPurchaseRefund from "@/components/member/PurchaseRefund.vue";
import MemberPurchaseQnA from "@/components/member/PurchaseQnA.vue";
import MemberDetail from "@/components/member/MemberDetail.vue";
import MemberPhoneNo from "@/components/member/MemberPhoneNo.vue";

// Dynamic Link
import Dynamic from "@/views/Dynamic.vue";
import DynamicExam from "@/components/dynamic/Exam.vue";
import DynamicDegree from "@/components/dynamic/Degree.vue";
import DynamicLearn from "@/components/dynamic/Learn.vue";
import DynamicSurvey from "@/components/dynamic/Survey.vue";

// Independent Exam
import IndependentExam from "@/views/Exam.vue";
import IndependentExamTotalView from "@/components/independentExam/TotalView.vue";
import IndependentExamMyView from "@/components/independentExam/MyView.vue";
import IndependentExamResultView from "@/components/independentExam/ResultView.vue";

// Independent Survey
import IndependentSurvey from "@/views/Survey.vue";
import IndependentSurveyTotalView from "@/components/independentSurvey/TotalView.vue";
import SurveyIntro from "@/components/survey/Intro.vue";
import SurveyTake from "@/components/survey/Take.vue";
import SurveyResult from "@/components/survey/Result.vue";
import SurveyFeedback from "@/components/survey/Feedback.vue";

// Prize Request
import PrizeRequest from "@/views/PrizeRequest.vue";
import PrizeRequestDetails from "@/components/prizeRequest/PrizeRequestDetails.vue";
import PurchaseDetails from "@/components/prizeRequest/PurchaseDetails.vue";
import PurchaseHistoryDetails from "@/components/prizeRequest/PurchaseInformation.vue";
import PurchaseCompleted from "@/components/prizeRequest/PurchaseCompleted.vue";
import PurchaseHistory from "@/components/prizeRequest/PurchaseHistory.vue";
import PointGuide from "@/components/prizeRequest/PointGuide.vue";


// Question
import QuestionList from "@/components/question/List.vue";

// Sample UI
import Sample from "@/views/Sample.vue";

//Social Learning
import MyPost from "@/components/socialLearning/MyPost";

import SocialLearningNoData from "@/components/socialLearning/SocialLearningNoData";
import SocialLearningDetails from "@/components/socialLearning/SocialLearningDetails";
import SocialLearningDisplayFile from "@/components/socialLearning/DisplayFile";
import SLWrite from "@/components/socialLearning/social-learning-write";
import SocialLearningComments from "@/components/socialLearning/SocialLearningComments";
import SocialLearningOverflowMenu from "@/components/socialLearning/SocialLearningOverflowMenu";
import SocialLearningOverflowMenuMyPost from "@/components/socialLearning/SocialLearningOverflowMenuMyPost";
import SocialLearningOverflowMenuSearchPost from "@/components/socialLearning/SocialLearningOverflowMenuSearchPost";
import SocialLearningOverflowMenuNoSearchResult from "@/components/socialLearning/SocialLearningNoSearchResult";
import SocialLearningOverflowMenuSearchResult from "@/components/socialLearning/SocialLearningOverflowMenuSearchResult";
// //Social Learning neaw
import SocialLearning from "@/views/SocialLearning.vue";
import SocialLearningList from "@/components/socialLearning/List.vue";
import SocialLearningView from "@/components/socialLearning/View.vue";

// Notice
import Notice from "@/views/Notice.vue";
import NoticeWrite from "@/components/notice/Write.vue";
import NoticeView from "@/components/notice/View.vue";

// E-Promoter
import EPromoterMyPost from "@/components/ePromoter/MyPost";

import EPromoterNoData from "@/components/ePromoter/EPromoterNoData";
import EPromoterWrite from "@/components/ePromoter/EPromoter-write";
import EPromoterComments from "@/components/ePromoter/EPromoterComments";
import EPromoterDisplayFile from "@/components/ePromoter/DisplayFile";

// //Social Learning new
import EPromoter from "@/views/EPromoter.vue";
import EPromoterList from "@/components/ePromoter/List.vue";
import EPromoterView from "@/components/ePromoter/View.vue";

// import Event from "@/components/event/Event4may";
import Event from "@/components/event/Event";
import EventDetail from "@/components/event/EventDetail";

// Drawer Langugae

// HelpDesk
import HelpDesk from "@/views/HelpDesk.vue";
import HelpDeskView from "@/components/helpDesk/View.vue";
import FaqDetail from "@/components/helpDesk/FaqDetail.vue";
import FaqDetail2 from "@/components/helpDesk/FaqDetail2.vue";
import InquiryDetail from "@/components/helpDesk/InquiryDetail.vue";
import InquiryDetailComment from "@/components/helpDesk/InquiryDetailComment.vue";
import InquiryDetailCommentImage from "@/components/helpDesk/InquiryDetailCommentImage.vue";
import InquiryDetailCommentReply from "@/components/helpDesk/InquiryDetailCommentReply.vue";
import NoData from "@/components/helpDesk/NoData.vue";

// Setting
import languageSearch from "@/components/languageSearch.vue";
//import Languages from '@/views/Language'
import Setting from "@/components/setting/Setting";
import AccessRight from "@/views/access-right";
import AppVersion from "@/views/app-version";

import Leader from "@/views/LeaderBoard.vue";

//Reward
import Reward from "@/components/reward/Reward.vue";
import RewardBadgeList from "@/views/RewardBagde.vue";
import RewardCertificateList from "@/components/reward/CertificateList.vue";
import BadgeDetail from "@/components/reward/BadgeDetail.vue";
import CertificateDetail from "@/components/reward/CertificateDetail.vue";

//Point
import Point from "@/views/Point.vue";
import PointEarn from "@/views/PointEarn.vue";

// Portfolio
import Portfolio from "@/components/portfolio/Portfolio.vue";
import BookMarkedLesson from "@/components/portfolio/BookMarkedLesson.vue";
import LikedLesson from "@/components/portfolio/LikedLesson.vue";
import SocialLearningLesson from "@/components/portfolio/SocialLearningLesson.vue";
import BookMarkedMission from "@/components/portfolio/BookMarkedMission.vue";

// VOC
import RadarWrite from "@/components/radar/Radar-write";
import Radar from "@/views/Radar.vue";
import radarView from "@/components/radar/View.vue";
import RadarDisplayFile from "@/components/radar/DisplayFile";
// import SocialLearningList from "@/components/socialLearning/List.vue";
// import SocialLearningView from "@/components/socialLearning/View.vue";

// CheckList
import CheckList from "@/components/checklist/List.vue";
import CheckListView from "@/components/checklist/View.vue";
import SubmittedResult from "@/components/checklist/SubmittedResult.vue";
import CheckListQuestionTake from "@/components/checklist/QuestionTake.vue";
import CheckListComment from "@/components/checklist/Comment.vue";

//Download App Page
import DownloadAppPage from "@/views/DownloadAppPage.vue";

Vue.use(Router);

//import NProgress from 'nprogress';

// Multi Language Set
import { setUserLanguage } from "@/translations/i18nSetup";
import brandApi from "@/api/brandApi.js";
import { log } from "util";
import { handleAutoLogin } from "@/utils/autoLoginUtil";
//import i18nApi from '@/api/i18nApi.js'

// Auth Check
const requireAuth = (to, form, next) => {
  const loginPath = `/login?redirectPath=${encodeURIComponent(to.path)}`;
  if (localStorage.getItem("token")) {
    loginApi
      .validToken()
      .then((response) => {
        next();
        return false;
      })
      .catch((err) => {
        localStorage.removeItem("token");
        next(loginPath);
      });
  } else {
    next(loginPath);
  }
};

const router = new Router({
  //mode: "history",
  mode: "hash",
  //base :'home',
  routes: [
    {
      path: "/sample",
      name: "sample",
      component: Sample,
    },
    {
      path: "/",
      name: "DownloadAppPage",
      component: DownloadAppPage,
      // redirect: "Login",
    },
    {
      path: "/brandselect",
      name: "BrandSelect",
      component: BrandSelect,
    },
    {
      path: "/popup",
      name: "Popup",
      component: Popup,
      // PC 모바일 타블렛 화면 분기 위한 개발 코드
      // components: {
      //     default: Home,
      //     pcRouter: PcHome
      // },
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu",
      },
    },
    {
      path: "/home",
      name: "Main",
      component: Main,
      beforeEnter: requireAuth,
      // PC 모바일 타블렛 화면 분기 위한 개발 코드
      // components: {
      //     default: Home,
      //     pcRouter: PcHome
      // },
      meta: {
        title: localStorage.getItem("brandName"),
        leftButton: "menu",
      },
    },

    {
      path: "/search",
      name: "Search",
      component: Search,
      beforeEnter: requireAuth,
    },

    {
      path: "/login",
      name: "Login",
      component: Login,
      // children: [
      //     { path: "/terms", name: "Terms", component: Terms },
      //     { path: "/privacy", name: "Privacy", component: Privacy },
      // ],
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms,
      //beforeEnter: requireAuth,
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: Privacy,
      //beforeEnter: requireAuth,
    },
    {
      path: "/emailvarification",
      name: "EmailConfirm",
      component: EmailConfirm,
      //beforeEnter: requireAuth,
    },
    {
      path: "/emailvarificationresend",
      name: "EmailReconfirm",
      component: EmailReconfirm,
      beforeEnter: requireAuth,
    },
    {
      path: "/resetpw",
      name: "resetpw",
      component: ResetPw,
      beforeEnter: requireAuth,
      meta: {},
    },

    {
      path: "/language",
      name: "language",
      component: languageSearch,
      beforeEnter: requireAuth,
      meta: {},
    },
    // {
    //     path: "/languages",
    //     name: "languages",
    //     beforeEnter: requireAuth,
    //     component: Languages
    //   },

    {
      path: "/setting",
      name: "setting",
      beforeEnter: requireAuth,
      component: Setting,
    },
    {
      path: "/helpdesk",
      name: "helpdesk",
      component: HelpDesk,
      beforeEnter: requireAuth,
      // meta: { TabType: "HelpDeskList", viewMode: "List" },
    },
    {
      path: "/nodata",
      name: "NoData",
      beforeEnter: requireAuth,
      component: NoData,
    },
    {
      path: "/faqdetail/:id",
      name: "FaqDetail",
      beforeEnter: requireAuth,
      component: FaqDetail,
    },
    {
      path: "/faq-detail/:id",
      name: "FaqDetail2",
      beforeEnter: requireAuth,
      component: FaqDetail2,
    },
    {
      path: "/inquiry-detail",
      name: "InquiryDetail",
      beforeEnter: requireAuth,
      component: InquiryDetail,
    },
    {
      path: "/inquiry-detail-comment",
      name: "InquiryDetailComment",
      beforeEnter: requireAuth,
      component: InquiryDetailComment,
    },
    {
      path: "/inquiry-detail-comment-image",
      name: "InquiryDetailCommentImage",
      beforeEnter: requireAuth,
      component: InquiryDetailCommentImage,
    },
    {
      path: "/inquiry-detail-comment-reply",
      name: "InquiryDetailCommentReply",
      beforeEnter: requireAuth,
      component: InquiryDetailCommentReply,
    },
    {
      path: "/access-right",
      name: "access-right",
      beforeEnter: requireAuth,
      component: AccessRight,
    },

    {
      path: "/app-version",
      name: "app-version",
      beforeEnter: requireAuth,
      component: AppVersion,
    },

    {
      path: "/event",
      name: "event",
      component: Event,
      beforeEnter: requireAuth,
      meta: {},
    },
    {
      path: "/event/:id",
      name: "EventDetail",
      beforeEnter: requireAuth,
      component: EventDetail,
    },
    {
      path: "/leader",
      name: "Leader",
      component: Leader,
      beforeEnter: requireAuth,
      meta: { TabType: "LeaderList", viewMode: "List" },
    },
    {
      path: "/findid",
      name: "FindId",
      component: FindId,
      redirect: "/findid/step1",
      children: [
        { path: "step1", name: "FindIdStep1", component: FindIdStep1 },
        { path: "step2", name: "FindIdStep2", component: FindIdStep2 },
        { path: "step3", name: "FindIdStep3", component: FindIdStep3 },
        { path: "step4", name: "FindIdStep4", component: FindIdStep4 },
        { path: "complete", name: "FindIdComplete", component: FindIdComplete },
      ],
    },
    // develop by Ankit
    {
      path: "/findcode",
      name: "FindCode",
      component: FindCode,
      redirect: "/findcode/step1",
      children: [
        { path: "step1", name: "FindCodeStep1", component: FindCodeStep1 },
      ],
    },

    {
      path: "/findpw",
      name: "FindPw",
      component: FindPw,
      redirect: "/findpw/step1",
      children: [
        { path: "step1", name: "FindPwStep1", component: FindPwStep1 },
        { path: "step2", name: "FindPwStep2", component: FindPwStep2 },
        { path: "step3", name: "FindPwStep3", component: FindPwStep3 },
        { path: "step4", name: "FindPwStep4", component: FindPwStep4 },
        { path: "step5", name: "FindPwStep5", component: FindPwStep5 },
        // { path: 'complete', name: 'FindPwComplete', component: FindPwComplete },
      ],
    },

    {
      path: "/join",
      name: "Join",
      component: Join,
      redirect: "/join/intro",
      children: [
        { path: "intro", name: "JoinIntro", component: JoinIntro },
        { path: "role", name: "JoinRole", component: JoinRole },
        {
          path: "responsibility",
          name: "JoinResponsibility",
          component: JoinResponsibility,
        },
        {
          path: "policy",
          name: "JoinPolicy",
          component: JoinPolicy,
          children: [
            { path: "terms", name: "JoinTerms", component: JoinTerms },
            { path: "privacy", name: "JoinPrivacy", component: JoinPrivacy },
          ],
        },
        { path: "name", name: "JoinName", component: JoinName },
        { path: "email", name: "JoinEmail", component: JoinEmail },
        { path: "password", name: "JoinPassword", component: JoinPassword },
        { path: "store", name: "JoinStore", component: JoinStore },
        { path: "complete", name: "JoinComplete", component: JoinComplete },
        {
          path: "existsocial",
          name: "JoinExistSocial",
          component: JoinExistSocial,
        },
        { path: "code", name: "JoinCode", component: JoinCode },
        {
          path: "socialinput",
          name: "JoinSocialInput",
          component: JoinSocialInput,
        },
      ],
    },

    {
      path: "/join2",
      name: "Join2",
      component: Join2,
      redirect: "/join2/intro",
      children: [
        { path: "intro", name: "Join2Intro", component: Join2Intro },
        {
          path: "policy",
          name: "Join2Policy",
          component: Join2Policy,
          children: [
            { path: "terms", name: "Join2Terms", component: JoinTerms },
            { path: "privacy", name: "Join2Privacy", component: JoinPrivacy },
          ],
        },

        {
          path: "responsibility",
          name: "Join2Responsibility",
          component: Join2Responsibility,
        },
        { path: "code", name: "Join2Code", component: Join2Code },

        { path: "name", name: "Join2Name", component: Join2Name },
        { path: "email", name: "Join2Email", component: Join2Email },
        { path: "password", name: "Join2Password", component: Join2Password },
        { path: "store", name: "Join2Store", component: Join2Store },
        {
          path: "completeapproved",
          name: "Join2CompleteApproved",
          component: Join2CompleteApproved,
        },
        {
          path: "completeunapproved",
          name: "Join2CompleteUnapproved",
          component: Join2CompleteUnapproved,
        },
        {
          path: "existsocial",
          name: "Join2ExistSocial",
          component: Join2ExistSocial,
        },
        {
          path: "socialinput",
          name: "Join2SocialInput",
          component: Join2SocialInput,
        },
      ],
    },

    {
      path: "/degree",
      name: "Degree",
      component: Degree,
      meta: { TabType: "DegreeList", viewMode: "List" },
      children: [
        {
          path: ":degreeId",
          name: "DegreeView",
          component: DegreeView,
          meta: { TabType: "", viewMode: "View" },
          children: [
            {
              path: "review",
              name: "DegreeReviewList",
              component: DegreeReviewList,
              props: true,
              meta: { TabType: "DegreeList", viewMode: "View" },
            },
            // {path: 'learn/:lessonId', name: 'DegreeLearnLesson', component: DegreeLearnLesson, props: true, meta: {TabType: 'DegreeList', viewMode: 'View'} },
            {
              path: "enterawait",
              name: "DegreeEnterAwait",
              component: DegreeEnterAwait,
              props: true,
              meta: { TabType: "DegreeList", viewMode: "View" },
            },
          ],
        },
      ],
    },
    {
      path: "/main",
      name: "main",
      component: Main,
      beforeEnter: requireAuth,
      meta: {},
    },
    {
      path: "/learn",
      name: "Learn",
      component: Learn,
      beforeEnter: requireAuth,
      meta: { TabType: "LearnList", viewMode: "List" },
      children: [
        {
          path: ":learnId",
          name: "LearnView",
          component: LearnView,
          beforeEnter: requireAuth,
          meta: { TabType: "LearnList", viewMode: "View" },
          children: [
            {
              path: ":lessonId/lessonContents/:progressionId",
              name: "LessonView",
              component: Study,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
              children: [
                {
                  path: "question",
                  name: "LessonViewQuestion",
                  component: QuestionList,
                  beforeEnter: requireAuth,
                  meta: {
                    TabType: "LearnList",
                    viewMode: "View",
                    chatType: "lesson",
                  },
                },
              ],
            },
            {
              path: ":lessonId/question",
              name: "LearnViewQuestion",
              component: QuestionList,
              beforeEnter: requireAuth,
              meta: {
                TabType: "LearnList",
                viewMode: "View",
                chatType: "lesson",
              },
            },

            {
              path: "lessonExam/:examineeId/intro",
              name: "LessonExamIntro",
              component: ExamIntro,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
            },
            {
              path: "lessonExam/:examineeId/take",
              name: "LessonExamTake",
              component: ExamTake,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
            },
            {
              path: "lessonExam/:examineeId/result",
              name: "LessonExamResult",
              component: ExamResult,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
            },
            {
              path: "lessonExam/:examineeId/feedback/:paperId",
              name: "LessonExamFeedback",
              component: ExamFeedback,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
              children: [
                {
                  path: "issue/:questionId",
                  name: "LessonExamFeedbackIssue",
                  component: ExamFeedbackIssue,
                  beforeEnter: requireAuth,
                  meta: { TabType: "LearnList", viewMode: "View" },
                },
                {
                  path: "question/:questionId",
                  name: "LessonExamFeedbackQuestion",
                  component: QuestionList,
                  beforeEnter: requireAuth,
                  meta: {
                    TabType: "LearnList",
                    viewMode: "View",
                    chatType: "exam",
                  },
                },
              ],
            },

            {
              path: "finalExam/:examineeId/intro",
              name: "FinalExamIntro",
              component: ExamIntro,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
            },
            {
              path: "finalExam/:examineeId/take",
              name: "FinalExamTake",
              component: ExamTake,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
            },
            {
              path: "finalExam/:examineeId/result",
              name: "FinalExamResult",
              component: ExamResult,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
            },
            {
              path: "finalExam/:examineeId/feedback/:paperId",
              name: "FinalExamFeedback",
              component: ExamFeedback,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
              children: [
                {
                  path: "issue/:questionId",
                  name: "FinalExamFeedbackIssue",
                  component: ExamFeedbackIssue,
                  beforeEnter: requireAuth,
                  meta: { TabType: "LearnList", viewMode: "View" },
                },
                {
                  path: "question/:questionId",
                  name: "FinalExamFeedbackQuestion",
                  component: QuestionList,
                  beforeEnter: requireAuth,
                  meta: {
                    TabType: "LearnList",
                    viewMode: "View",
                    chatType: "exam",
                  },
                },
              ],
            },

            {
              path: "mission/:assignmentId",
              name: "LearnViewMission",
              component: LearnViewMission,
              beforeEnter: requireAuth,
              meta: { TabType: "LearnList", viewMode: "View" },
              children: [
                {
                  path: "submit",
                  name: "LearnViewMissionSubmit",
                  component: LearnViewMissionSubmit,
                  beforeEnter: requireAuth,
                  meta: { TabType: "LearnList", viewMode: "View" },
                },
                {
                  path: "update/:answerId",
                  name: "LearnViewMissionUpdate",
                  component: LearnViewMissionSubmit,
                  beforeEnter: requireAuth,
                  meta: { TabType: "LearnList", viewMode: "View" },
                },
              ],
            },

            {
              path: "question/:lessonId/:roomId",
              name: "LessonQuestion",
              component: QuestionList,
              beforeEnter: requireAuth,
              meta: {
                TabType: "LearnList",
                viewMode: "View",
                chatType: "lesson",
              },
            },
          ],
        },
      ],
    },
    {
      path: "/socialLearning",
      name: "SocialLearning",
      component: SocialLearning,
      beforeEnter: requireAuth,
      meta: { TabType: "SocialLearningList", viewMode: "List" },
      children: [
        // {
        //   path: "/",
        //   name: "SocialLearningList",
        //   component: SocialLearningList,
        //   beforeEnter: requireAuth,
        //   meta: { TabType: "SocialLearningView", viewMode: "List" },
        // },
        {
          path: ":postId",
          name: "SocialLearningView",
          component: SocialLearningView,
          beforeEnter: requireAuth,
          meta: { TabType: "SocialLearningView", viewMode: "View" },
        },
      ],
    },
    {
      path: "/notice",
      name: "Notice",
      component: Notice,
      beforeEnter: requireAuth,
      children: [
        {
          path: ":postId",
          name: "NoticeView",
          component: NoticeView,
          beforeEnter: requireAuth,
        }
      ],
    },
    {
      path: "/notice/write",
      name: "NoticeWrite",
      beforeEnter: requireAuth,
      component: NoticeWrite,
    },
    {
      path: "/ePromoter",
      name: "EPromoter",
      component: EPromoter,
      beforeEnter: requireAuth,
      // meta: { TabType: "EPromoterList", viewMode: "List" },
      children: [
        // {
        //   path: "/",
        //   name: "SocialLearningList",
        //   component: SocialLearningList,
        //   beforeEnter: requireAuth,
        //   meta: { TabType: "SocialLearningView", viewMode: "List" },
        // },
        {
          path: ":postId",
          name: "EPromoterView",
          component: EPromoterView,
          beforeEnter: requireAuth,
          meta: { TabType: "EPromoterView", viewMode: "View" },
        },

      ],
    },
    {
      path: "/ePromoter-mypost",
      name: "EPromoterMyPost",
      beforeEnter: requireAuth,
      component: EPromoterMyPost,
    },
    {
      path: "/ePromoter-write",
      name: "EPromoterWrite",
      beforeEnter: requireAuth,
      component: EPromoterWrite,
    },
    {
      path: "/ePromoter/:postId/edit",
      name: "EPEdit",
      beforeEnter: requireAuth,
      component: EPromoterWrite,
    },
    {
      path: "/ePromoter_listing_nodata",
      name: "EPromoterNoData",
      beforeEnter: requireAuth,
      component: EPromoterNoData,
    },
    {
      path: "/ePromoter_comments",
      name: "EPromoterComments",
      beforeEnter: requireAuth,
      component: EPromoterComments,
    },
    {
      path: "/study/:learnId/:progressionId",
      name: "study",
      component: Study,
      beforeEnter: requireAuth,
      meta: {},
    },
    {
      path: "/e-Promoter/file-display",
      name: "EPromoterDisplayFile",
      beforeEnter: requireAuth,
      component: EPromoterDisplayFile,
    },
    {
      path: "/sales",
      name: "Sales",
      component: Sales,
      beforeEnter: requireAuth,
      children: [
        {
          path: "duplicate/:goodsid",
          name: "SalesDuplicate",
          component: SalesDuplicate,
          beforeEnter: requireAuth,
          meta: { TabType: "" },
        },
        {
          path: "information/:goodsid",
          name: "SalesInformation",
          component: SalesInformation,
          beforeEnter: requireAuth,
          meta: { TabType: "" },
        },
        {
          path: "cart/:goodsid",
          name: "SalesCart",
          component: SalesCart,
          beforeEnter: requireAuth,
          meta: { TabType: "" },
        },

        {
          path: "resultbank/:orderId",
          name: "SalesResultBank",
          component: SalesResultBank,
          beforeEnter: requireAuth,
          meta: { TabType: "" },
        },
        {
          path: "resultpaypal/:orderId",
          name: "SalesResultPaypal",
          component: SalesResultPaypal,
          beforeEnter: requireAuth,
          meta: { TabType: "" },
        },
        {
          path: "resultenroll/:orderId",
          name: "SalesResultEnroll",
          component: SalesResultEnroll,
          beforeEnter: requireAuth,
          meta: { TabType: "" },
        },
      ],
    },
    {
      path: "/member/changepassword",
      name: "MemberChangePassword",
      component: MemberChangePassword,
      beforeEnter: requireAuth,
    },
    {
      path: "/member/reissuechangepassword",
      name: "MemberReIssueChangePassword",
      component: MemberReIssueChangePassword,
      beforeEnter: requireAuth,
    },
    {
      path: "/member",
      name: "Member",
      component: Member,
      redirect: "",
      children: [
        // {
        //   path: "changepassword",
        //   name: "MemberChangePassword",
        //   component: MemberChangePassword,
        //   beforeEnter: requireAuth,
        // },

        {
          path: "profilePatten",
          name: "MemberProfilePatten",
          component: MemberProfilePatten,
          beforeEnter: requireAuth,
        },
        {
          path: "profilePicture",
          name: "MemberProfilePicture",
          component: MemberProfilePicture,
          beforeEnter: requireAuth,
        },
        {
          path: "myinfo",
          name: "MemberDetail",
          component: MemberDetail,
          beforeEnter: requireAuth,
        },
        {
          path: "myphone",
          name: "MemberPhoneNo",
          component: MemberPhoneNo,
          beforeEnter: requireAuth,
        },
        {
          path: "purchase",
          name: "MemberPurchase",
          component: MemberPurchase,
          beforeEnter: requireAuth,
          children: [
            {
              path: ":orderId",
              name: "MemberPurchaseView",
              component: MemberPurchaseView,
              beforeEnter: requireAuth,
            },
            {
              path: "refund/:orderId",
              name: "MemberPurchaseRefund",
              component: MemberPurchaseRefund,
              beforeEnter: requireAuth,
            },
            {
              path: "qna/:orderId",
              name: "MemberPurchaseQnA",
              component: MemberPurchaseQnA,
              beforeEnter: requireAuth,
            },
          ],
        },
        {
          path: "Withdrawal",
          name: "Withdrawal",
          component: Withdrawal,
          beforeEnter: requireAuth
        },
      ],
    },

    {
      path: "/certification",
      name: "certification",
      component: Certification,
      beforeEnter: requireAuth,
      meta: {},
    },

    {
      path: "/reason-choice",
      name: "ReasonChoice",
      component: ReasonChoice,
      beforeEnter: requireAuth,
      meta: {},
    },

    {
      path: "/error",
      name: "Error",
      component: Error,
      meta: {},
      children: [{ path: "network", name: "Network", component: ErrorNetwork }],
    },

    {
      path: "/dynamic",
      name: "Dynamic",
      component: Dynamic,
      children: [
        {
          path: ":brandCode/exam/:distId",
          name: "DynamicExam",
          component: DynamicExam,
        },
        {
          path: ":brandCode/degree",
          name: "DynamicDegree",
          component: DynamicDegree,
        },
        {
          path: ":brandCode/degree/:degreeId",
          name: "DynamicDegreeView",
          component: DynamicDegree,
        },
        {
          path: ":brandCode/learn",
          name: "DynamicLearn",
          component: DynamicLearn,
        },
        {
          path: ":brandCode/survey/:distId",
          name: "DynamicSurvey",
          component: DynamicSurvey,
        },
      ],
    },

    // 단독 시험
    {
      path: "/independent/exam",
      name: "IndependentExam",
      component: IndependentExam,
      meta: { TabType: "ExamList", viewMode: "List" },
      children: [
        {
          path: ":distId",
          name: "IndependentExamTotalView",
          component: IndependentExamTotalView,
          meta: { TabType: "ExamList", viewMode: "View" },
        },
        {
          path: "my/:examineeId",
          name: "IndependentExamMyView",
          beforeEnter: requireAuth,
          component: IndependentExamMyView,
          meta: { TabType: "ExamList", viewMode: "View" },
          children: [
            {
              path: "intro",
              name: "IndependentExamIntro",
              component: ExamIntro,
              meta: { TabType: "ExamList", viewMode: "View" },
            },
            {
              path: "take",
              name: "IndependentExamTake",
              component: ExamTake,
              meta: { TabType: "ExamList", viewMode: "View" },
            },
          ],
        },
        {
          path: "result/:examineeId",
          name: "IndependentExamResultView",
          beforeEnter: requireAuth,
          component: IndependentExamResultView,
          meta: { TabType: "ExamList", viewMode: "View" },
          children: [
            {
              path: "take",
              name: "IndependentExamResultTake",
              component: ExamTake,
              meta: { TabType: "ExamList", viewMode: "View" },
            },
            {
              path: "result",
              name: "IndependentExamResultResult",
              component: ExamResult,
              meta: { TabType: "ExamList", viewMode: "View" },
            },
            {
              path: "feedback/:paperId",
              name: "IndependentExamResultFeedback",
              component: ExamFeedback,
              meta: { TabType: "ExamList", viewMode: "View" },
              children: [
                {
                  path: "issue/:questionId",
                  name: "IndependentExamResultFeedbackIssue",
                  component: ExamFeedbackIssue,
                  meta: { TabType: "ExamList", viewMode: "View" },
                },
                {
                  path: "question/:questionId",
                  name: "IndependentExamResultFeedbackQuestion",
                  component: QuestionList,
                  meta: {
                    TabType: "ExamList",
                    viewMode: "View",
                    chatType: "exam",
                  },
                },
              ],
            },
          ],
        },
      ],
    },

    // 단독 설문
    {
      path: "/independent/survey",
      name: "IndependentSurvey",
      component: IndependentSurvey,
      meta: { TabType: "SurveyList", viewMode: "List" },
      children: [
        {
          path: ":distId",
          name: "IndependentSurveyTotalView",
          component: IndependentSurveyTotalView,
          meta: { TabType: "SurveyList", viewMode: "View" },
          children: [
            {
              path: ":respondentId/intro",
              name: "IndependentSurveyIntro",
              beforeEnter: requireAuth,
              component: SurveyIntro,
              meta: { TabType: "SurveyList", viewMode: "View" },
            },
            {
              path: ":respondentId/take",
              name: "IndependentSurveyTake",
              beforeEnter: requireAuth,
              component: SurveyTake,
              meta: { TabType: "SurveyList", viewMode: "View" },
            },
            {
              path: ":respondentId/result",
              name: "IndependentSurveyResult",
              beforeEnter: requireAuth,
              component: SurveyResult,
              meta: { TabType: "SurveyList", viewMode: "View" },
            },
            {
              path: ":respondentId/feedback",
              name: "IndependentSurveyFeedback",
              beforeEnter: requireAuth,
              component: SurveyFeedback,
              meta: { TabType: "SurveyList", viewMode: "View" },
            },
          ],
        },
      ],
    },
    {
      path: "/mypost",
      name: "MyPost",
      beforeEnter: requireAuth,
      component: MyPost,
    },
    {
      path: "/social-learning/write",
      name: "SLWrite",
      beforeEnter: requireAuth,
      component: SLWrite,
    },
    {
      path: "/social-learning/:postId/edit",
      name: "SLEdit",
      beforeEnter: requireAuth,
      component: SLWrite,
    },
    {
      path: "/social_learning_listing_nodata",
      name: "SocialLearningNoData",
      beforeEnter: requireAuth,
      component: SocialLearningNoData,
    },
    {
      path: "/social_learning_details",
      name: "SocialLearningDetails",
      beforeEnter: requireAuth,
      component: SocialLearningDetails,
    },
    {
      path: "/file-display",
      name: "SocialLearningDisplayFile",
      beforeEnter: requireAuth,
      component: SocialLearningDisplayFile,
    },
    {
      path: "/social_learning_comments",
      name: "SocialLearningComments",
      beforeEnter: requireAuth,
      component: SocialLearningComments,
    },
    {
      path: "/social_learning_overflow_menu",
      name: "SocialLearningOverflowMenu",
      beforeEnter: requireAuth,
      component: SocialLearningOverflowMenu,
    },
    {
      path: "/social_learning_overflow_menu_mypost",
      name: "SocialLearningOverflowMenuMyPost",
      beforeEnter: requireAuth,
      component: SocialLearningOverflowMenuMyPost,
    },
    {
      path: "/social_learning_overflow_menu_searchpost",
      name: "SocialLearningOverflowMenuSearchPost",
      beforeEnter: requireAuth,
      component: SocialLearningOverflowMenuSearchPost,
    },
    {
      path: "/social_learning_overflow_menu_nosearch",
      name: "SocialLearningOverflowMenuNoSearchResult",
      beforeEnter: requireAuth,
      component: SocialLearningOverflowMenuNoSearchResult,
    },
    {
      path: "/social_learning_overflow_menu_searchresults",
      name: "SocialLearningOverflowMenuSearchResult",
      beforeEnter: requireAuth,
      component: SocialLearningOverflowMenuSearchResult,
    },
    {
      path: "/point",
      name: "Point",
      beforeEnter: requireAuth,
      component: Point,
    },
    {
      path: "/pointearn",
      name: "PointEarn",
      beforeEnter: requireAuth,
      component: PointEarn,
    },
    {
      path: "/pointearn/:id",
      name: "PointEarn",
      beforeEnter: requireAuth,
      component: PointEarn,
    },
    {
      path: "/reward",
      name: "Reward",
      beforeEnter: requireAuth,
      component: Reward,
    },
    {
      path: "/rewardbadgelist",
      name: "RewardBadgeList",
      component: RewardBadgeList,
      beforeEnter: requireAuth,
      meta: { TabType: "RewardBadgeList", viewMode: "RewardBadgeList" },
    },
    {
      path: "/rewardcertificatelist",
      name: "RewardCertificateList",
      component: RewardCertificateList,
      beforeEnter: requireAuth,
      //meta: { TabType: "RewardCertificateList", viewMode: "RewardCertificateList" },
    },
    {
      path: "/badgedetail/:boxid/:missionid",
      name: "BadgeDetail",
      beforeEnter: requireAuth,
      component: BadgeDetail
    },
    {
      path: "/badgedetail/:boxid/:missionid",
      name: "BadgeDetail",
      beforeEnter: requireAuth,
      component: BadgeDetail
    },
    {
      path: "/certificatedetail/:id",
      name: "CertificateDetail",
      beforeEnter: requireAuth,
      component: CertificateDetail
    },
    {
      path: "/portfolio",
      name: "Portfolio",
      beforeEnter: requireAuth,
      component: Portfolio
    },
    {
      path: "/bookmarked-lesson",
      name: "BookMarkedLesson",
      beforeEnter: requireAuth,
      component: BookMarkedLesson
    },
    {
      path: "/liked-lesson",
      name: "LikedLesson",
      beforeEnter: requireAuth,
      component: LikedLesson
    },
    {
      path: "/social-lesson",
      name: "SocialLearningLesson",
      beforeEnter: requireAuth,
      component: SocialLearningLesson
    },
    {
      path: "/bookmarked-mission",
      name: "BookMarkedMission",
      beforeEnter: requireAuth,
      component: BookMarkedMission
    },
    {
      path: "/prize-request",
      name: "PrizeRequest",
      beforeEnter: requireAuth,
      meta: { TabType: "PrizeRequest", viewMode: "List" },
      component: PrizeRequest
    },
    {
      path: "/prize-request-details/:prizeid",
      name: "PrizeRequestDetails",
      beforeEnter: requireAuth,
      component: PrizeRequestDetails
    },
    {
      path: "/purchase-details/:prizeid/:qty",
      name: "PurchaseDetails",
      beforeEnter: requireAuth,
      component: PurchaseDetails
    },
    {
      path: "/purchase-completed/:prizeid",
      name: "PurchaseCompleted",
      beforeEnter: requireAuth,
      component: PurchaseCompleted
    },
    // {
    //   path: "/purchase-information",
    //   name: "PurchaseInformation",
    //   beforeEnter: requireAuth,
    //   component: PurchaseInformation
    // },

    {
      path: "/purchase-history",
      name: "PurchaseHistory",
      beforeEnter: requireAuth,
      component: PurchaseHistory
    },
    {
      path: "/point-guide",
      name: "PointGuide",
      beforeEnter: requireAuth,
      component: PointGuide
    },
    {
      path: "/purchase-history-details/:prizeid",
      name: "PurchaseHistoryDetails",
      beforeEnter: requireAuth,
      component: PurchaseHistoryDetails
    },
    {
      path: "/termsagree",
      name: "termsagree",
      component: TermsAgree,
    },

    {
      path: "/verificationcode",
      name: "verificationcode",
      component: VerificationCode,
    },
    {
      path: "/radar",
      name: "Radar",
      component: Radar,
      beforeEnter: requireAuth,
      meta: { TabType: "Radar", viewMode: "List" },
      children: [
        {
          path: ":postId",
          name: "radarView",
          component: radarView,
          beforeEnter: requireAuth,
          meta: { TabType: "radarView", viewMode: "View" },
        },
      ],
    },
    {
      path: "/radar-write",
      name: "RadarWrite",
      beforeEnter: requireAuth,
      component: RadarWrite,
    },
    {
      path: "/radar-write/:postId",
      name: "RadarWrite",
      beforeEnter: requireAuth,
      component: RadarWrite,
    },
    {
      path: "/radar/file-display",
      name: "RadarDisplayFile",
      beforeEnter: requireAuth,
      component: RadarDisplayFile,
    },

    {
      path: "/checklist",
      name: "CheckList",
      component: CheckList,
      beforeEnter: requireAuth
  },
  {
      path: "/checklist/:postId",
      name: "CheckListView",
      beforeEnter: requireAuth,
      component: CheckListView
  },
  {
      path: "/submit-result/:postId",
      name: "SubmittedResult",
      beforeEnter: requireAuth,
      component: SubmittedResult
  },
  {
      path: "/questiontake/:postId",
      name: "CheckListQuestionTake",
      beforeEnter: requireAuth,
      component: CheckListQuestionTake
  },
  {
      path: "/questiontake/comment/:postId",
      name: "CheckListComment",
      beforeEnter: requireAuth,
      component: CheckListComment
  },
  ],
});

// Check Brand Info
function checkBrandInfo() {
  return !!(
    localStorage.getItem("brandCode") &&
    localStorage.getItem("brandName") &&
    localStorage.getItem("brandLogo") &&
    localStorage.getItem("brandCompany")
  );
}

// 라우터 이동시 체크(router move check)
router.beforeEach((to, from, next) => {
  console.log("== routes to, from", to, from)

  console.log("[라우터] route push, deviceOS > ", to.query.tokens, to.query.deviceOS);
  if (to.query.tokens) {
    localStorage.setItem("fbToken", to.query.tokens);
  }
  if (to.query.deviceOS) {
    localStorage.setItem("deviceOS", to.query.deviceOS);
  }
  
  let isOnline = navigator.onLine;
  let routerPath = to.path;
  let redirectPath = encodeURIComponent(from.path);

  if (isOnline) {
    let stateBrandInfo = checkBrandInfo();
    
    // 브랜드 선택 화면, 로그인 화면 일 경우 handleAutoLogin 함수 실행
    if (to.name === "BrandSelect" || to.name === "Login") {
      console.log(to.name)
      handleAutoLogin(next, to);
    }

    if (from.path === "/learn" && from.query.searched == 1) {
      from.query.searched = null
      router.push(`/learn?status=${from.query.status}&category=${from.query.category}&searched=null`);
      location.reload();
    }

    else if (to.path === "/" && (from.path === "/ePromoter" || from.path === "/socialLearning")) {
      router.push("/home");
    }

    else if (to.name === "BrandSelect" || to.name === "DownloadAppPage") {
      next();
      // })
    } else {

      // 브랜드 선택화면이 아니면(is brand select screen)
      if (to.name.indexOf("Dynamic") >= 0) {
        next();
        return false;
      }

      if (stateBrandInfo) {
        // 브랜드 정보 정상이면 언어 체크(language check)
        window.BRAND_CODE = localStorage.getItem("brandCode");
        window.BRAND_NAME = localStorage.getItem("brandName");
        window.BRAND_LOGO = localStorage.getItem("brandLogo");
        window.BRAND_COMPANY = localStorage.getItem("brandCompany");

        // 브랜드 담당자 정보 설정(set brand Manager info)
        brandApi.brandManager().then((response) => {
          window.BRAND_MANAGER_NAME = response.data.data.name;
          window.BRAND_MANAGER_EMAIL = response.data.data.email;
          window.BRAND_MANAGER_PHONE = response.data.data.phone;
        });
        setUserLanguage().then(() => {
          next();
        });
      } else {
        router.push("/brandselect");
      }
    }
  } else {
    if (routerPath.indexOf("error") === -1)
      next("/error/network?redirectPath=" + redirectPath);
    else {
      next();
    }
  }
});

// router.beforeResolve((to, from, next) => {
//     if (to.name) {
//         NProgress.start()
//     }
//     next()
//   })

//   router.afterEach((to, from) => {
//     NProgress.done()
//   })

export default router;
